export default "/react/ozonIcon-7f6e000d.svg";